import { EyeOutlined } from '@ant-design/icons';
import { Badge, Card, Tooltip } from 'antd';
import { useHistory } from 'react-router-dom';
import {
  DATE_FORMATS,
  FULFILLMENT_STATUS,
  LIBRARY_ALL_DELIVERY_TABLE_ACTIONS_OPTIONS,
  NEW_ORDER_TABLE_ACTIONS_OPTIONS,
  ORDER_STATUS,
  PAYMENT_TYPE,
  PII_FIELD_TYPES,
  PLAN_NAMES,
  PLAN_TYPES,
  PLAY_PLAN_NAME,
  ROUTES,
  STATUS,
  USER_LIBRARY_TYPE,
} from '../../../../../common/constants';
import { formatDate, getPlayPlanLabel } from '../../../../../common/utils';
import RevealPiiValue from '../../../../../components/RevealPiiValue';

const AllUserCard = ({
  user,
  infiniteScrollRef,
  handleOrderChange,
  setIsAllOrderItemModalOpen,
  isNewPath,
  setIsNotePrompts,
  setIsOrderAction,
  handleChallanDownload,
  isChallanLoading,
  handleChallanReset,
  isResetLoading,
  setVisible,
  setToyImages,
  handleSelectOrders,
  selectedOrders,
  setIsReasonPrompt,
}) => {
  const handleMenuClick = (e) => {
    handleOrderChange(e?.key, user);
  };
  const history = useHistory();

  let selectedValue = null;
  if (
    user?.status === ORDER_STATUS?.CANCELLED?.value ||
    user?.status === ORDER_STATUS?.CONFIRMED?.value
  ) {
    if (user?.status === ORDER_STATUS?.CANCELLED?.value) {
      selectedValue = FULFILLMENT_STATUS?.UNFULFILLED?.value;
    } else {
      selectedValue = FULFILLMENT_STATUS?.FULFILLED?.value;
    }
  } else {
    selectedValue = null;
  }

  const menuProps = isNewPath
    ? {
        items: NEW_ORDER_TABLE_ACTIONS_OPTIONS?.map((item) => ({
          label: item?.label,
          key: item?.value,
        })),
        onClick: handleMenuClick,
        disabled: !!selectedValue,
      }
    : {
        items: LIBRARY_ALL_DELIVERY_TABLE_ACTIONS_OPTIONS?.map((item) => ({
          label: item?.label,
          key: item?.value,
        })),
        onClick: handleMenuClick,
        disabled:
          user?.status === ORDER_STATUS?.CANCELLED?.value ||
          user?.status === ORDER_STATUS?.DELIVERED?.value ||
          user?.status === ORDER_STATUS?.SHIPPED?.value ||
          user?.status === ORDER_STATUS?.NOT_DELIVERED?.value,
      };

  const shippedAttachments =
    user?.deliveryAttachments?.filter(
      (attachment) =>
        attachment?.deliveryAttachmentsType === ORDER_STATUS?.SHIPPED?.value,
    ) || [];

  const deliveredAttachments =
    user?.deliveryAttachments?.filter((attachment) =>
      [ORDER_STATUS?.DELIVERED?.value, null]?.includes(
        attachment?.deliveryAttachmentsType,
      ),
    ) || [];

  const bankAccounts = user?.bankAccounts?.filter(
    (account) => account?.isDefault,
  );
  const allBankAccounts = bankAccounts?.map((bankAccount) => {
    if (bankAccount?.type === PAYMENT_TYPE?.ACCOUNT) {
      return `(Name. ${bankAccount?.holderName}) (No. ${bankAccount?.accountNumber}) (IFSC: ${bankAccount?.ifsc})`;
    }
    return ` (UPI ID: ${bankAccount.upiId}) `;
  });

  const primaryLibrary = user?.userLibraries?.find(
    (lib) => lib?.type === USER_LIBRARY_TYPE?.PRIMARY?.value,
  );

  const additionalLibrary = user?.userLibraries?.find(
    (lib) => lib?.type === USER_LIBRARY_TYPE?.ADDITIONAL?.value,
  );
  const { name, libraryNumber } = primaryLibrary?.library || {};

  const {
    name: additionalLibraryName,
    libraryNumber: additionalLibraryNumber,
  } = additionalLibrary?.library || {};

  return (
    <Card
      className="ml-12 mr-12 mb-24 mt-12 mobile-card"
      title={
        <div className="overflow-scroll no-scroll-bar align-center">
          {user?.userNumber}{' '}
        </div>
      }
      ref={infiniteScrollRef}
      onClick={() => {
        setIsAllOrderItemModalOpen(true);
      }}
    >
      <div>
        <div
          className="mb-8 text-primary"
          onClick={() => {
            history?.push(
              `${ROUTES?.ORDERS}${ROUTES?.COMBINED_ORDERS}${ROUTES?.NEW}/${user?.id}`,
            );
          }}
        >
          <span>
            <EyeOutlined className="mr-8" />
          </span>
          <span className="mobile-card-label text-primary">OPEN ORDERS</span>
        </div>

        <div
          className="mb-8 text-primary"
          onClick={() => {
            history?.push(
              `${ROUTES?.ORDERS}${ROUTES?.COMBINED_ORDERS}${ROUTES?.RETURN}/${user?.id}`,
            );
          }}
        >
          <span>
            <EyeOutlined className="mr-8" />
          </span>
          <span className="mobile-card-label text-primary">
            OPEN RETURN ORDERS
          </span>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">USER NAME: </span>
          <span>
            {(
              <>
                {user?.firstName || user?.lastName ? (
                  <div className="table-data-with-id">{`${
                    user?.firstName ? user?.firstName : ''
                  } ${user?.lastName ? user?.lastName : ''}`}</div>
                ) : (
                  '-'
                )}
                {user?.userNumber ? (
                  <div className="font-size-12">({user?.userNumber})</div>
                ) : (
                  ''
                )}
              </>
            ) || '-'}
          </span>
        </div>
        <div className="mb-8">
          <span className="mobile-card-label ">EMAIL: </span>
          <div className="user-email" title={user?.email || '-'}>
            <RevealPiiValue
              value={user?.email}
              userId={user?.id}
              field={PII_FIELD_TYPES?.EMAIL}
            />
          </div>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">CONTACT: </span>
          <span>
            <RevealPiiValue
              value={user?.contactNo}
              userId={user?.id}
              field={PII_FIELD_TYPES?.CONTACT}
            />
          </span>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">BILLING CYCLE: </span>
          <span>
            {PLAN_TYPES?.[user?.subscription?.subscriptionPlan?.type]?.key ||
              '-'}
          </span>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">PLAN SUBSCRIBED: </span>
          <span>
            {user?.subscription?.subscriptionPlan?.name?.includes(
              PLAY_PLAN_NAME,
            )
              ? getPlayPlanLabel(user?.subscription?.subscriptionPlan)
              : PLAN_NAMES?.[user?.subscription?.subscriptionPlan?.name]?.key ||
                '-'}
          </span>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">
            PRIMARY MAPPED LIBRARY NAME:{' '}
          </span>
          <span>
            <>
              <div className="table-data-with-id">
                {name || user?.pincode?.library?.name}
              </div>
              <div className="font-size-12">
                {libraryNumber || user?.pincode?.library?.libraryNumber
                  ? `(${
                      libraryNumber || user?.pincode?.library?.libraryNumber
                    })`
                  : '-'}
              </div>
            </>
          </span>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">
            ADDITIONAL MAPPED LIBRARY NAME:{' '}
          </span>
          <span>
            <>
              {additionalLibraryName ? (
                <>
                  <div className="table-data-with-id">
                    {additionalLibraryName}
                  </div>
                  <div className="font-size-12">
                    ({additionalLibraryNumber})
                  </div>
                </>
              ) : (
                '-'
              )}
            </>
          </span>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">USER SINCE: </span>
          <span>
            {formatDate(user?.createdAt, DATE_FORMATS?.REGULAR) || '-'}
          </span>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">ACCOUNT DETAILS: </span>
          <span>
            {' '}
            <>
              {bankAccounts?.length > 0 ? (
                <Tooltip
                  title={allBankAccounts}
                  placement="topLeft"
                  trigger="click"
                  className="pointer"
                >
                  {allBankAccounts}
                </Tooltip>
              ) : (
                '-'
              )}
            </>{' '}
          </span>{' '}
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">LAT: </span>
          <span>{user?.latLong?.coordinates?.[1] || '-'}</span>
        </div>

        <div className="mb-8">
          <span className="mobile-card-label">LNG: </span>
          <span>{user?.latLong?.coordinates?.[0] || '-'}</span>
        </div>
        <div className="mb-8">
          <span className="mobile-card-label">STATUS: </span>
          <span>
            {' '}
            <Badge
              color={
                user?.isActive ? STATUS?.ACTIVE?.color : STATUS?.INACTIVE?.color
              }
              text={
                user?.isActive ? STATUS?.ACTIVE?.label : STATUS?.INACTIVE?.label
              }
            />
          </span>
        </div>
      </div>
    </Card>
  );
};

export default AllUserCard;
